import { Grid } from "@material-ui/core";
import React from "react";
import { DataCard, DataCardDefaultItem } from "@ofqual/portal-components/components/DataCard/DataCard";
import { QualificationModel } from "../../domain/QualificationModel";
import { DownloadLink } from "@ofqual/portal-components/components/DownloadLink";
import { expertsApplyService } from "../../services/index"
import { useSelector } from "react-redux";
import { authSelector } from "../../redux/selectors";
import { FileInput } from "@ofqual/portal-components/components/FileInput";
import { SectionProps } from "./SectionProps";
import { ExpertsApplyModel } from "../../domain/ExpertsApplyFormModel";
import { Controller } from "react-hook-form";

export const Qualifications: React.FC<{
  qualifications: QualificationModel[],
  sectionProps: SectionProps<ExpertsApplyModel>;
}> = ({ qualifications, sectionProps: { control } }) => {

  const { token } = useSelector(authSelector);
  const buildGetBlob = (blobId: string, id: string, qualId: string) => () =>
    expertsApplyService.downloadQualificationAttachment(
      id,
      qualId,
      blobId,
      {
        token,
      }
    );
  const displayEducationDetails = (qualification: QualificationModel) => {
    const items: DataCardDefaultItem[] = [

      {
        itemType: "DEFAULT",
        key: "College, school, training provider, university or other organisation",
        value: qualification.schoolName,
      },
      {
        itemType: "DEFAULT",
        key: "Awarding organisation",
        value: qualification.organisationName,
      },
      {
        itemType: "DEFAULT",
        key: "Qualification, course, subject or title",
        value: qualification.qualificationName,
      },
      {
        itemType: "DEFAULT",
        key: "Grade",
        value: qualification.grade,
      },
      {
        itemType: "DEFAULT",
        key: "Year awarded",
        value: String(qualification.yearAwarded),
      },
      {
        itemType: "DEFAULT",
        key: "Are you able to upload a copy of a certificate for this qualification?",
        value: qualification.canUpload ? "yes" : "no",
      }
    ]
    if (!qualification.canUpload) {
      items.push(
        {
          itemType: "DEFAULT",
          key: "Provide a reason for not being able to upload a copy of a certificate for this qualification",
          value: qualification.reasonCantUpload,
        }
      )
    }
    return items
  }

  return (
    <>
      <div style={{ overflowWrap: 'break-word' }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <>
              <DataCard
                showHeading={false}
                heading={null}
                items={[
                  {
                    itemType: "DEFAULT",
                    key:
                      "Do you have any qualifications that are relevant to your application?",
                    value: qualifications.length > 0 ? "Yes" : "No",
                  },
                ]}
                hasAction={false}
                actionDescription={null}
                actionButtonText={null}
                actionFunction={null}
                headingComponent={"h1"}
              />
              <br />
              {qualifications ? (
                qualifications.map((qualification, index) => (
                  <React.Fragment key={index}>
                    {index > 0 ? <br /> : <></>}
                    <DataCard
                      showHeading={true}
                      heading={qualification.qualificationName}
                      items={displayEducationDetails(qualification)}
                      hasAction={false}
                      actionDescription={null}
                      actionButtonText={null}
                      actionFunction={null}
                      headingComponent={"h1"}
                      optionalComponent={
                        <>
                          <Grid item xs={12}>
                            <Controller
                              control={control}
                              name={`qualifications[${index}].uploadFile`}
                              defaultValue={[]}
                              as={
                                <FileInput
                                  dataTest="select-files-button"
                                  id={`file-upload-btn-[${index}]`}
                                />
                              }
                            />
                          </Grid>
                          {qualification.canUpload && (
                            <Grid item xs={12} data-test="download-file-link">
                              <DownloadLink
                                fileName={
                                  qualification.supportingDocument?.fileName ?? 'File not found!'
                                }
                                getBlob={buildGetBlob(
                                  qualification.supportingDocument?.blobId ?? '',
                                  qualification.expertApplyId,
                                  qualification.id
                                )}
                              />
                            </Grid>
                          )}
                        </>
                      }
                    />
                    {/* {qualification.canUpload ? (
                      <DownloadLink
                        fileName={
                          qualification.supportingDocument?.fileName ?? 'File not found!'
                        }
                        getBlob={buildGetBlob(
                          qualification.supportingDocument?.blobId ?? '',
                          qualification.expertApplyId,
                          qualification.id
                        )}
                      />
                    ) : (
                      <></>
                    )} */}
                    <br />
                  </React.Fragment>
                ))
              ) : (
                <></>
              )}
            </>
          </Grid>
        </Grid>
      </div>
    </>
  );
}
  ;
